import React, { Component } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, Label, Nav, } from 'reactstrap';
import PropTypes from 'prop-types';
import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import logo from '../../assets/img/brand/logo.png'
import Labellogo from '../../assets/img/brand/login.png'
import defaultpic from '../../assets/img/avator/user-default.png'
import sygnet from '../../assets/img/brand/sygnet.gif'
import { logout } from '../../api/Login';
import * as actions from '../../actions';

const propTypes = {
    children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {
    async logOut() {
        let res = await logout();
        this.props.history.push({ pathname: "/" })
        await this.props.keepUser(res.data);
        //window.location.replace('/login');
    }
    changeRoute(path) {
        this.props.history.push({ pathname: path })
    }
    render() {
        // eslint-disable-next-line
        const { children, ...attributes } = this.props;
        return (
            <React.Fragment>
                <AppSidebarToggler className="d-lg-none" display="md" mobile />
                <Link to={this.props.auth ? "/dashboard" : "/"} className="left brand-logo" >
                    <AppNavbarBrand
                        full={{ src: logo, width: 60, height: 60, alt: 'ELM Logo' }}
                        // full={{ src: Labellogo, width: 80, height: 55, alt: 'GNM Logo' }}
                        minimized={{ src: logo, width: 30, height: 30, alt: 'ELM Logo' }}
                    />
                </Link>
                <AppSidebarToggler className="d-md-down-none" display="lg" />
                <Nav className="ml-auto" navbar>
                    <AppHeaderDropdown direction="down">
                        {this.props.auth ? '' : <Link to="/login">Login</Link>}
                        <DropdownToggle nav draggable="false">
                            <img src={this.props.auth.profilePicture || defaultpic}
                                // <img src={defaultpic}
                                width="30" height="30"
                                style={{ border: '1px', borderRadius: 10 }}
                                alt="pp"
                                draggable="false"
                            >
                            </img>
                            {this.props.auth ? <strong style={{ padding: 10 }}>{this.props.auth.displayName}</strong> : ''}
                        </DropdownToggle>
                        <DropdownMenu right style={{ right: 'auto' }}>
                            <DropdownItem header tag="div" className="text-center"><strong>Settings</strong></DropdownItem>
                            <DropdownItem onClick={() => this.changeRoute(`/user/myprofile`)}><i style={{ color: 'gray', fontWeight: 'bold' }} className="fa fa-id-card-o"> my profile</i></DropdownItem>
                            {<DropdownItem onClick={() => this.changeRoute(`/user/changepassword`)}><i style={{ color: 'gray', fontWeight: 'bold' }} className="fa fa-cog"> change password</i></DropdownItem>}
                            <DropdownItem onClick={() => this.logOut()}><i style={{ color: 'gray', fontWeight: 'bold' }} className="fa fa-sign-out"> logout </i></DropdownItem>
                        </DropdownMenu>
                    </AppHeaderDropdown>
                </Nav>
            </React.Fragment>
        );
    }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

function mapStateToProps(state) {
    return { auth: state.auth };
}

export default connect(mapStateToProps, actions)(DefaultHeader);

